import global from "global";

export default () => new URL(global.location.href);
